<!-- 获取停车位置信息 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody:{
                "parkCode":"2KNTYVWC",
                "parkingCode":"",
                "carCode":"粤EXX123",
                "returnCarImage":0,
                "returnLocateImage":0,
                "pictureFormat":0
            },
            responseCode: {
                "status": 1,
                "resultCode": 0,
                "message": "业务成功",
                "data": {
                    "carNO": "粤XXXXX1",
                    "enterTime": "2018-01-01 00:00:00",
                    "floorNO": "B1",
                    "carportNO": "A1001",
                    "carImage": "http://img.xxx.xin/xxx.jpg",
                    "locateImage":"http://img.xxx.xin/xxx.jpg"
                }
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取停车位置相关信息",
                t_url: this.commonUrls.test+"getParkingPosition",
                p_url: this.commonUrls.prod+"getParkingPosition",
                precondition: "无",
                fitSystem: "VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'carCode', info2: 'carCode和parkingCode必选一个', info3: 'String', info4: '车牌号' },
                        { info1: 'parkingCode', info2: 'carCode和parkingCode必选一个', info3: 'String', info4: '停车流水号' },
                        { info1: 'returnCarImage', info2: '否', info3: 'int', info4: '是否返回车身图片；0：不返回，1返回；默认0' },
                        { info1: 'returnLocateImage', info2: '否', info3: 'int', info4: '是否返回位置缩略图；0：不返回，1返回；默认0' },
                        { info1: 'pictureFormat', info2: '否', info3: 'int', info4: '图片格式,0:http链接，1:BASE64编码；默认0' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'carCode', info2: '是', info3: 'String', info4: '车牌号' },
                        { info1: 'enterTime', info2: '是', info3: 'String', info4: '停入时间（指停入停车位时间；yyyy-MM-dd HH:mm:ss）' },
                        { info1: 'floorNO', info2: '是', info3: 'String', info4: '楼层编号' },
                        { info1: 'carportNO', info2: '是', info3: 'String', info4: '车位编号' },
                        { info1: 'carImage', info2: '否', info3: 'String', info4: '车身图片' },
                        { info1: 'locateImage', info2: '否', info3: 'String', info4: '位置缩略图' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/parking/guide/getParkingPosition.vue